import { render } from "./ClientFlowComponent.vue?vue&type=template&id=70fb45f6&scoped=true"
import script from "./ClientFlowComponent.vue?vue&type=script&lang=js"
export * from "./ClientFlowComponent.vue?vue&type=script&lang=js"

import "./ClientFlowComponent.vue?vue&type=style&index=0&id=70fb45f6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fb45f6"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QBtn,QInnerLoading});
